import type { PuzzleResult, Score } from '@/types';

/**
 * Calculates the player's score for a completed puzzle.
 *
 * Formula (PRD §11.1):
 *   base = tier × 100
 *   strikeBonus = (budget - strikesUsed) × 50
 *   undoBonus = undoUsed ? 0 : 100
 *   timeBonus = max(0, targetTimeSeconds - solveTimeSeconds) × 2
 *   resetPenalty = resetsUsed × -50
 *   total = base + strikeBonus + undoBonus + timeBonus + resetPenalty
 */
export function calculateScore(result: PuzzleResult): Score {
  const base = result.tier * 100;
  const strikeBonus = (result.strikeBudget - result.strikesUsed) * 50;
  const undoBonus = result.undoUsed ? 0 : 100;
  const timeBonus = Math.max(0, result.targetTimeSeconds - result.solveTimeSeconds) * 2;
  const resetPenalty = result.resetsUsed === 0 ? 0 : result.resetsUsed * -50;
  const total = base + strikeBonus + undoBonus + timeBonus + resetPenalty;

  return {
    base,
    strikeBonus,
    undoBonus,
    timeBonus,
    resetPenalty,
    total,
  };
}
